import React, { useEffect } from 'react';

const DispatchedJobScreen = () => {

    return (
        <div className="unbody">
            <div className="uacontainer">
                <h1 className="unh1">Job Dispatched</h1>
                <p className="unp">Please check with Admin Team to Work on dispatched data.</p>
            </div>
        </div>
    );
}

export default DispatchedJobScreen;